import {
  Checkbox,
  Grid,
  L88,
  P,
  Radio,
  Stack,
  Text
} from "@adfenix/alexandria";
import { ProgramService } from "@adfenix/types";
import { Fragment } from "react";
import { useFormContext } from "react-hook-form";
import styled from "styled-components";
import { MetaFormKey } from "./util/formKey";
import { useDisabledFields } from "../useDisabledFields";

interface Props {
  campaignKey: MetaFormKey;
}

const adTypes: ProgramService.AdType[] = ["LinkAd", "AlbumAd", "VideoAd"];

const StyledGrid = styled(Grid)`
  display: grid;
  max-width: 300px;
  gap: 0;
`;

const GridHeading = styled.div`
  margin-bottom: 8px;
`;

const Col = styled.div`
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid ${({ theme }) => L88(theme.colors.grey)};
`;

export const AdTypes = ({ campaignKey }: Props) => {
  const disabledFields = useDisabledFields();

  const { register, watch } = useFormContext<ProgramService.ProgramModel>();
  const overrideCustomerAdTypeSettings = watch(
    `${campaignKey}.overrideCustomerAdTypeSettings`
  );

  return (
    <Stack spacing="xs">
      <P>Ad types</P>
      <Checkbox
        {...register(`${campaignKey}.overrideCustomerAdTypeSettings`)}
        label="Override customer ad type settings"
        readOnly={disabledFields(
          "bundleGroups.bundles.campaignTemplates.overrideCustomerAdTypeSettings"
        )}
      />

      <StyledGrid columns={["92% 8%"]}>
        {overrideCustomerAdTypeSettings && (
          <>
            <GridHeading>
              <Text>Ad type available to pick from</Text>
            </GridHeading>

            <GridHeading style={{ justifySelf: "end" }}>
              <Text>Default</Text>
            </GridHeading>

            {adTypes.map(adType => (
              <Fragment key={adType}>
                <Col>
                  <Checkbox
                    id={adType}
                    value={adType}
                    {...register(`${campaignKey}.availableAdTypes`)}
                    label={adType.replace("Ad", "")}
                    readOnly={disabledFields(
                      "bundleGroups.bundles.campaignTemplates.availableAdTypes"
                    )}
                  />
                </Col>

                <Col>
                  <Radio
                    id={`radio${adType}`}
                    value={adType}
                    data-testid={`default-${adType}`}
                    {...register(`${campaignKey}.selectedAdType`, {
                      required: overrideCustomerAdTypeSettings
                        ? "You must select a default ad type when you have overridden the customer ad type settings."
                        : false
                    })}
                    readOnly={disabledFields(
                      "bundleGroups.bundles.campaignTemplates.selectedAdType"
                    )}
                  />
                </Col>
              </Fragment>
            ))}
          </>
        )}
      </StyledGrid>
    </Stack>
  );
};
